function safeParseCustomJson(customJson) {
	if (!customJson) return {};
	if (typeof customJson === "object") return customJson || {};
	if (typeof customJson !== "string") return {};

	let parsedValue = customJson;
	for (let index = 0; index < 3; index += 1) {
		if (parsedValue && typeof parsedValue === "object") {
			return parsedValue;
		}
		if (typeof parsedValue !== "string") {
			return {};
		}
		try {
			parsedValue = JSON.parse(parsedValue);
		} catch (error) {
			return {};
		}
	}
	return parsedValue && typeof parsedValue === "object" ? parsedValue : {};
}

function parseFeatureFlagValue(value) {
	if (value === true || value === 1) return true;
	if (typeof value === "string") {
		const normalized = value.trim().toLowerCase();
		return normalized === "true" || normalized === "1";
	}
	return false;
}

function getPreRollFlagFromRadio(radio) {
	const parsedCustomJson = safeParseCustomJson(radio && radio.custom_json);
	const features = parsedCustomJson && parsedCustomJson.features;
	if (!features || typeof features !== "object") return false;
	return parseFeatureFlagValue(
		features.mobadsPreRoll !== undefined
			? features.mobadsPreRoll
			: features.mobads_preroll
	);
}

export default function canUsePreRoll({ user, radio }) {
	const isAdmin = Number(user && user.level) === 0;
	const isFeatureEnabledForRadio = getPreRollFlagFromRadio(radio);

	return {
		isAdmin,
		isFeatureEnabledForRadio,
		canUse: isAdmin || isFeatureEnabledForRadio,
	};
}
